import _ from '@lodash';
import { AppBar, Toolbar, DialogContent, DialogActions, TextField, Typography, InputAdornment } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import * as Helpers from 'app/Core/Helpers';
import AgendamentoEdicaoApp from 'app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import MobileDetect from 'mobile-detect';
import { makeStyles } from "@material-ui/styles";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";

const md = new MobileDetect(window.navigator.userAgent);

class EmpresaPessoaProdutoDialog extends XAPPComponent {

    state = {
        open: false,
        valor: 0,
        percentual: 0,
        valorservico: 0,
    }

    componentDidUpdate(prevProps, prevState) {
        const { item } = this.props;
        if (this.state.open && !_.isEqual(prevState.open, this.state.open) && !_.isNull(item)) {
            this.setState({
                ...this.state,
                idpessoaformulariorelacionamento: item.idpessoaformulariorelacionamento,
                valor: item.formulario?.valor,
                percentual: item.formulario?.percentual,
                valorservico: item.formulario?.valorservico,
            });
        }
    }

    canBeSubmitted = () => {
        const { valor, percentual, valorservico } = this.state;
        return (
            valor !== null && valor !== "" &&
            percentual !== null && percentual !== "" &&
            valorservico !== null && valorservico !== ""
        )
    }

    openDialog = (_AValue) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    }

    handleChangeValor = (ev) => {
        let AObj = {};

        switch (ev.target.name) {
            case "valorservico":
                AObj.valorservico = Number(ev.target.value);
                AObj.valor = Number((AObj.valorservico * (this.state.percentual / 100)).toFixed(2));
                break;
            case "valor":
                AObj.valor = Number(ev.target.value);
                AObj.percentual = Number(((AObj.valor / this.state.valorservico) * 100).toFixed(2));
                break;
            case "percentual":
                AObj.percentual = Number(ev.target.value);
                AObj.valor = Number((this.state.valorservico * (AObj.percentual / 100)).toFixed(2));
                break;
        }


        this.setState({ ...this.state, ...AObj });
    }

    render() {
        const { classes, xappRouteParams, save, listFilter, disablePersonFields = false, } = this.props;
        const form = this.state;
        return (
            <>
                <XAPPButton
                    tooltip={{ "title": "Editar", "placement": "top" }}
                    className="p-12"
                    icon={"edit"}
                    type={"icon"}
                    onClick={() => this.openDialog(true)}
                />
                <XAPPDialog
                    id="EmpresaPessoaProduto"
                    classes={{ paper: "m-24" }}
                    open={form.open}
                    onClose={() => this.openDialog(false)}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth="sm"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {"Editar valores"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <XAPPButton
                                tooltip={{ "title": "Fechar", "placement": "top" }}
                                className="p-6"
                                icon={"close"}
                                iconProps={"text-white"}
                                type={"icon"}
                                onClick={() => this.openDialog(false)}
                            />
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-24" }}>
                        {form.open &&
                            <div className="">
                                <TextField
                                    className="mb-16"
                                    label="Valor do serviço"
                                    required
                                    id="valorservico"
                                    name="valorservico"
                                    value={form.valorservico}
                                    onChange={this.handleChangeValor}
                                    variant="outlined"
                                    fullWidth
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                    }}
                                />
                                {!disablePersonFields &&
                                    <TextField
                                        className="mb-16"
                                        label="Percentual do profissional"
                                        required
                                        id="percentual"
                                        name="percentual"
                                        value={form.percentual}
                                        onChange={this.handleChangeValor}
                                        variant="outlined"
                                        fullWidth
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                        }}
                                    />
                                }
                                {!disablePersonFields &&
                                    <TextField
                                        className="mb-16"
                                        label="Valor do profissional"
                                        required
                                        id="valor"
                                        name="valor"
                                        value={form.valor}
                                        onChange={this.handleChangeValor}
                                        variant="outlined"
                                        fullWidth
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                        }}
                                    />
                                }
                            </div>
                        }
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions className="mx-0">
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white m-0 "
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        let AObj = {
                                            idpessoaformulariorelacionamento: this.state.idpessoaformulariorelacionamento,
                                            formulario: { ...this.state }
                                        }
                                        save("ATUALIZAR", AObj, xappRouteParams, listFilter);
                                    }
                                    }
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </>
        );
    }
}

export default EmpresaPessoaProdutoDialog;
